import __vue_component__ from './Tab.vue.js';

var script = {
  name: 'Tabs',
  functional: true,

  render(h, {
    slots,
    props,
    listeners
  }) {
    const {
      tabs = [],
      content = []
    } = slots();
    return [h('nav', tabs.map(vnode => {
      const {
        componentOptions,
        data: {
          attrs,
          staticClass
        }
      } = vnode;
      return h(__vue_component__, {
        props: { ...componentOptions.propsData,
          selected: props.value
        },
        attrs: { ...attrs
        },
        class: { ...(staticClass && {
            [staticClass]: true
          })
        },
        on: { ...listeners
        }
      }, [vnode]);
    })), h('div', [content.find(({
      componentOptions
    }) => componentOptions.propsData.id === props.value)])];
  }

};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tabs/TabContainer.vue_rollup-plugin-vue=script.js